import React from 'react';
import {Select, MenuItem} from '@material-ui/core';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';


export default function Comp(props) {
  const [difficultyNames, setDifficultyNames] = React.useState([]);
  const [difficultyForBox, setDifficultyForBox] = React.useState("Any");

  React.useEffect(() => {    
    if(props.open){      
      populateDifficulty();
    }
  }, [props.open]);

  function populateDifficulty(){
    if(props.difficultyIds && props.difficultyIds?.length>0){
      let idsArr = props.difficultyIds?.split(",");
      let nameArr = props.difficultyNames?.split(",");
      let diffArr = [];
      for(let i=0; i<idsArr.length; i++){
        diffArr[i]=idsArr[i]+"#"+nameArr[i];
      }
      setDifficultyNames(diffArr);
    }else{
      let diffArr = [];
      diffArr[0]="0#Any";
      setDifficultyNames(diffArr);
    }
  }

  React.useEffect(() => {
    if(difficultyNames && difficultyNames.length>0){      
      let aaStr="", difIds="", difNames="";      
      for(let i=0; i<difficultyNames?.length; i++){
        aaStr+=difficultyNames[i].split("#")[1];
        difIds+=difficultyNames[i].split("#")[0];
        difNames+=difficultyNames[i].split("#")[1];
        if(i<difficultyNames?.length-1){
          aaStr+=", ";
          difIds+=",";
          difNames+=",";
        }
      }      
        setDifficultyForBox(aaStr);
        props.updateDifficultyNames(difIds,difNames);
    }
  }, [difficultyNames]);

  const handleDifficultyNames = (event) => {
    const {
      target: { value },
    } = event;
    setDifficultyNames(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  function checkSelectedDifficulty(id){
    let rtrn = false;
    if(difficultyNames && difficultyNames.length>0){
      for(let i=0; i<difficultyNames.length; i++){
        if(id===parseInt(difficultyNames[i].split("#")[0])){
          rtrn = true;
        }
      }
    }else if(id===0){
      rtrn = true;
    }
    return rtrn;
  }

  return (<>
            <Select
              style={{width:'100%'}}
              labelId="demo-multiple-name-label"
              id="demo-multiple-name"
              multiple
              value={difficultyNames}
              onChange={handleDifficultyNames}  
              renderValue={(selected) => difficultyForBox}                                  
            >
              <MenuItem key={'difany'} value={0+'#'+'Any'} >
                <Checkbox checked={checkSelectedDifficulty(0)} />
                <ListItemText primary="Any" />
              </MenuItem>
              {props.difficultyList.map((row,i) => (
                  <MenuItem key={'tchr'+i} value={row.autoId+'#'+row.difficultyName} >
                    <Checkbox checked={checkSelectedDifficulty(row.autoId)} />
                    <ListItemText primary={row.difficultyName} />
                  </MenuItem>
              ))}
            </Select>
  </>);
}
